import React from "react";

const introText = ({ spc, station_type, stype, user_id, signUpOpen }) => {
  //  console.log("introtext", spc, station_type, stype, user_id, signUpOpen);
  if (user_id !== 0) {
    return null;
  }
  if (station_type != 0 || spc > 4) {
    return null;
  }

  let copy = null;
  if (spc == 1 && stype == "seed") {
    copy = (
      <div>
        <strong>
          Jango plays unlimited music for free and with no commercials.
        </strong>
        <br />
        <br />
        Our goal is to play you the music you love and introduce you to your
        future favorites.
        <br />
        <br />
        You are listening to your first station, and you can configure it to
        your tastes.
      </div>
    );
  } else if (spc == 2 && stype == "jsi") {
    copy = (
      <div>
        <strong>Why did we play this?</strong>
        <br />
        <br />
        In addition to the artists you specifically ask to hear, we will play
        similar artists.
        <br />
        <br />
        Sit back and relax and we will keep the music playing - when you hear
        something you like, click the heart icon and we&apos;ll use that info to
        influence what you hear next.
        <br />
        <br />
        Hear something you don&apos;t like? Sorry about that! Just click
        &quot;Don&apos;t play again&quot; and we&apos;ll make a note of it.
      </div>
    );
  } else if (spc == 3 && stype == "ra") {
    copy = (
      <div>
        Jango partners with Radio Airplay, a service that wants to introduce
        unsigned artists to potential fans like you.
        <br />
        <br />
        If you like what you hear, show them some love and give them a good
        rating - it will influence how much exposure they get on Jango.
      </div>
    );
  } else if ((spc == 4 || spc == 3) && stype == "seed") {
    copy = (
      <div>
        <strong>Save your stations by Signing Up!</strong>
        <br />
        <br />
        If you like this station you should{" "}
        <strong>
          <a className="action-underline"
            onClick={(e) => {
              e?.preventDefault();
              signUpOpen();
            }}
            href="#"
          >
            Sign Up
          </a>
        </strong>{" "}
        so we can save it for you and it will be waiting the next time you
        visit, exactly as you left it!
        <br />
        <br />
      </div>
    );
  }
  return copy && <div className="intro-text">{copy}</div>;
};
export default introText;
